export const locale = {
    lang: 'zh1',
    data: {
      'DISPATCH': {
        'ENCUESTA_PILOTO': '試行調研',
        'ENCUESTA_PILOTO_ENVIO': '發送試點調查',
        'ENCUESTA_LANZAMIENTO':'啟動確認',
        'BTN_COPY':'複製調查碼 ',
        ////*******Tab Crear Encuestas********************************///
        'CREAR_ENCUESTA':'創建調查',
        'ENCUESTA_DEMO':'試點調查',
        'BOTON_CREAR_ENCUESTA':'產生調查',
        'SEE_TI': '请参阅技术要求',
        'CLAVE': '存取資料',
        'ACCESO': '存取',
        'NOFECHA':'您無法執行此操作，因為沒有啟動日期',
        'LABEL01': '複製存取代碼並粘貼到試行調研',
        'LABEL02': '調查的發送已確認',
        'LABEL03': '電子郵件',
        'LABEL04': '發送試點調查',
        'LABEL05': '錯誤',
        'LABEL06': '試點調查已正確發送',
        'LABEL07': '必填項目',
        'LABEL09': '調查演示用戶已經筋疲力盡',
        'CONFIRMAR_ENVIO': '確認發送電子郵件',
        'DES_CONFIRMAR_ENVIO': '不確認發送電子郵件',
        'SI_CONFIRMAR_ENVIO': '是',
        'NO_CONFIRMAR_ENVIO': '沒有',
        'CHANGE-OPTIONS':'更改郵件選項',
        'NO_ENVIO_CORREO':'沒有郵件將被發送',
        'SI_ENVIO_CORREO':'郵件將被發送',
        'EN_CASO':'如果選擇「否」，則所有關於調查的通訊郵件都將於平台之外進行，即平台不會向用戶發送電子郵件。',
        'CONFIRMAR_ENVIO_35': '確認調查提交', // 少一點
        'AUTOLOG_35': '調查自動登錄鏈接：',
        'TITULO':'在本部分中，您將可以對調查進行測試運行：',
        'LINK':'1.訪問以下鏈接：',
        'CLAVE_ENCUESTA':'2.複製此測試密鑰：',
        'INSTRUCCION3':'3.將密鑰粘貼到密碼單元格中',
        'INSTRUCCION4':'4.點擊登錄',
        'TEXTO_CONFIRMAR':'確認將通過電子郵件與用戶進行通信（邀請和提醒）',
        'TEXTO_CONFIRMAR2':'如果您不想發送郵件，只需跳過單擊並關閉步驟',
        'TITULO_PILOTO':'在此部分中，您將能夠在真正啟動調查之前將參與邀請郵件發送給最多五個不同的協作者，以測試郵件的接收和調查的可視化：',
        'INSTRUCCION_PILOTO':'1.輸入電子郵件，然後選擇要用於接收邀請的語言',
        'INSTRUCCION_PILOTO2':'2.單擊發送按鈕',
        'SELLANG': '選擇一種語言',
        'MENSAJES':{
           'MSN_INGR_COD':'<span> 要確認不會發送邀請或提醒電子郵件，請在文本框中輸入紅色代碼 ',
           'MSN_INGR_COD2':'</span>',
           'MSN_CHANGE-CONFI':'配置已修改',

        'BTN_MODALES':{
          'CONFIRMAR':'確認',
          'SALIR':'出口',
        }
        },
        'URL35':{ // Sive unicamente para dispatch de la norma 35
          'MAS50':'更多 50',
          'MENOS50':'少一點 50'
        },

        'CERTIFICAR2':{ // Sive unicamente para crear encuesta de certificar 2.0
          'LINK':'1.訪問以下鏈接：',
          'CLAVE_ENCUESTA':'2. 複製“演示用戶”部分中生成的密鑰之一',
          'INSTRUCCION3':'3.將密鑰粘貼到密碼單元格中',
          'INSTRUCCION4':'4.點擊登錄',
          'USERSDEMO':'演示用戶',
          'USERS':'用戶',
          'CLAVE':'鍵',
          'ESTATUS':'狀態',
          'ESTATUS-USER-ASIGNA':'已分配',
          'INST_UPD_URL_NAME':'通過最多輸入6個字符的用戶熟悉的文本來自定義ShortUrl。',
          'BTN_UPD_GUARDA':'救',
          'BTN_UPD_CAN':'取消',
          'CUS_SHOI_URL':'自定義調查URL',
          'MODAL_ACTU_CUS_SHOI_URL':'更新網址中的名稱',
          'ACTU_CUS_SHOI_URL_OK':'網址中的名稱已正確更新',
          'ACTU_CUS_SHOI_URL_FALSE':'網址中的名稱已經存在',
        },


        'ALERT':{
            'HEADER':'信息',
            'MESSAGE_CON': '¿您要確認向用戶發送電子郵件?',
            'MESSAGE': '¿您是否要確認向合作者發送電子郵件?',
            'MESSAGE_DESCON': '¿您一定不要確認向用戶發送電子郵件?',
            'BTN_CANCEL': '不，請取消',
            'BTN_CONFIRM': '是，請發送',
            'BTN_NO_CONFIRM': '不，發送',
            'BTN_SI_CONFIRM': '是的，發送',
            'BTN_NO_CANCEL': '取消',
            'BTN_OK': '是',
            'SINCOLABS': '您還無法發送調查邀請，必須先上傳公司參與者列表',
            'SINLANG': '您尚未為輸入的一個或多個電子郵件地址選擇一種語言',
            'ERRMAIL': '輸入的電子郵件語法不正確，請檢查並再次輸入'
        }

      },
      'PULSE':{
              'LABEL01': '將調查發送給您的合作者',
      }
    }
};
